import {Component} from '@angular/core';
import {MessageGridSelected} from '../../messages/message-grid-selected';
import {DataRow} from '../../DoraData/data-row';
import {WidgetBaseGridComponent} from '../widget-base/widget-base-grid.component';
import {DataTuplaDescription} from '../../DoraData/data-tupla-description';
import {MessageColumnsSelected} from '../../messages/message-columns-selected';
import {TUPLA_TYPE} from '../../DoraData/data-base';

@Component({
  selector: 'dora-column-selector',
  template: ''
})
/**
 * Base widget
 */
export class DoraColumnSelectorComponent extends WidgetBaseGridComponent {


  protected onNewData(): void {
    super.onNewData();

    // select all number column
    this.dataGrid.selectColumnsByType(TUPLA_TYPE.NUMBER);

    // fire event
    this.sendMessage();
  }

  protected selectionChanged(columnId: string, selected: boolean): void {
    let dataTuplaDescription: DataTuplaDescription;
    dataTuplaDescription = this.dataGrid.getTuplaDescription(columnId);

    if (dataTuplaDescription === undefined) {
      console.error('Column not found. Id: ' + columnId);
      return;
    }

    // add or remove column
    dataTuplaDescription.selected = selected;

    // fire event
    this.sendMessage();
  }

  private sendMessage(): void {
    const ids: string[] = [];
    this.dataGrid.getSelectedColumns().forEach(tuplaDescription => {
      ids.push(tuplaDescription.Id);
    });

    this.messageService.sendMessage(this.EventChannel, new MessageColumnsSelected(ids), this.CallerName);
  }
}
